import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import omit from 'lodash/omit';
import MultiPlatformFieldLabel from './MultiPlatformFieldLabel';
import ResourceFormProxy from 'classes/ResourceFormProxy';
import {isNoU} from "../../utils/DBUtils";

/**
 * Renders a given component once for the Master platform and once for each possible platform
 */
class MultiPlatformField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      otherPlatformsVisible: false
    };
  }

  toggleOtherPlatformsVisibility = () => {
    this.setState({otherPlatformsVisible: !this.state.otherPlatformsVisible});
  };

  render() {
    const AutoSaveFieldComponent = this.props.fieldComponent;
    let sharedProps = omit(this.props,
      "fieldComponent",
      "dailybreakEnabled",
      "demoEnabled",
      "embedEnabled"
    );

    let possiblePlatforms = [];

    if (this.props.dailybreakEnabled) {
      possiblePlatforms.push("DAILYBREAK");
    }

    if (this.props.demoEnabled) {
      possiblePlatforms.push("DEMO");
    }

    if (this.props.embedEnabled) {
      possiblePlatforms.push("EMBED");
    }

    return (
      <div>
        {/* Render the component with the currently selected platform first, and in its own section */}
        <AutoSaveFieldComponent platform={this.props.currentPlatform}
                                {...sharedProps}
                                fieldLabel={
                                  <MultiPlatformFieldLabel fieldPath={this.props.fieldPath}
                                                           resourcePath={this.props.resourcePath}
                                                           formProxy={this.props.formProxy}
                                                           field={this.props.field}
                                                           sectionIndex={this.props.sectionIndex}
                                                           toggleOtherPlatformsVisibility={this.toggleOtherPlatformsVisibility}/>
                                }
        />

        {/*  Loop through all possible platforms, check which ones we happen to have for this object,
          and display those below the selected platform.  This section can be toggled visible or not by
          an accordion or some other sort of display that is TBD */}

        {this.state.otherPlatformsVisible ?
          <div className="multi-platform-fields">
            {possiblePlatforms.map((platform, index) => {
              return (
                <div className={"animResponse fadeInDown mp-field-" + platform}>
                  <AutoSaveFieldComponent platform={platform}
                                          key={"MultiPlatformField" + index}
                                          {...sharedProps}/>
                  <div className={"field-icon mp-field-icon-" + platform}/>
                </div>
              );
            })}
          </div>
          : ""}
      </div>);
  }
}

MultiPlatformField.propTypes = {
  fieldComponent: PropTypes.node,
  // Specify enabled platforms individually to avoid re-renders that can be caused by an array reference
  // TODO: Look into creating a static reference to enabled platforms array
  dailybreakEnabled: PropTypes.bool.isRequired,
  demoEnabled: PropTypes.bool.isRequired,
  embedEnabled: PropTypes.bool.isRequired,

  currentPlatform: PropTypes.string.isRequired,
  resourcePath: PropTypes.arrayOf(PropTypes.string).isRequired,
  fieldPath: PropTypes.arrayOf(PropTypes.string).isRequired,
  field: PropTypes.object.isRequired,
  formProxy: PropTypes.instanceOf(ResourceFormProxy),
  fieldKey: PropTypes.string.isRequired,
  sectionIndex: PropTypes.number,
  reducerKey: PropTypes.string,
};

MultiPlatformField.defaultProps = {};

const mapState = (state) => {
  if (isNoU(state.editBreak.break)) {
    return {
      dailybreakEnabled: false,
      demoEnabled: false,
      embedEnabled: false,
    }
  }

  return {
    dailybreakEnabled: !isNoU(state.editBreak.break.DAILYBREAK),
    demoEnabled: !isNoU(state.editBreak.break.DEMO),
    embedEnabled: !isNoU(state.editBreak.break.EMBED),
  };
};

export default connect(mapState, null)(MultiPlatformField);



// WEBPACK FOOTER //
// ./public/components/forms/MultiPlatformField.jsx